// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1dC4G","button":"styles_button__KNo37"};